import { Button } from "@/components/ui/button";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/components/ui/input-otp";
import { Separator } from "@/components/ui/separator";
import { Spinner } from "@/components/ui/spinner";
import { useCountdown } from "@/hooks/use-countdown";
import { useVerifyVouch } from "@/hooks/use-verify-vouch";
import { formatTime } from "@/lib/utils";
import { REGEXP_ONLY_DIGITS } from "input-otp";
import { PenLine } from "lucide-react";
import { useNavigate } from "react-router";

const OTP_SLOT_COUNT = 6;

const slotIndexes = Array.from({ length: OTP_SLOT_COUNT }, (_, index) => index);

const VouchingVerify = () => {
  const navigate = useNavigate();
  const {
    phone,
    otpError,
    otpRef,
    handleComplete,
    resendOtp,
    isSubmitting,
    isResending,
  } = useVerifyVouch();
  const { timeLeft, isRunning, reset } = useCountdown(30);

  return (
    <section className="hero px-6">
      <div className="animate-screen flex flex-col items-start gap-5">
        <div className="flex  min-w-0 flex-col gap-2">
          <h2 className="text-2xl leading-tight text-foreground">
            Enter code
          </h2>
          <p className="text-sm text-muted-foreground">
            We've sent a code to your WhatsApp.
          </p>
          <p className="text-sm text-muted-foreground">
            <span className="font-semibold text-accent-foreground">
              {phone}
            </span>
          </p>
        </div>
        <InputOTP
          id="otp"
          ref={otpRef}
          autoFocus
          maxLength={OTP_SLOT_COUNT}
          pattern={REGEXP_ONLY_DIGITS}
          onComplete={(value) => {
            otpRef.current?.blur(); // dismisses the iOS grabbers
            handleComplete(value);
          }}
          disabled={isSubmitting}
        >
          <InputOTPGroup className="flex  w-full items-center justify-center gap-x-3">
            {slotIndexes.map((index) => (
              <InputOTPSlot key={index} index={index} />
            ))}
          </InputOTPGroup>
        </InputOTP>
        {otpError && <p className="text-sm text-destructive">{otpError}</p>}
        {isSubmitting && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Spinner data-icon="inline-start" />
            Verifying...
          </div>
        )}
        {isRunning && !isSubmitting ? (
          <p className="text-sm text-muted-foreground">
            Resend code in{" "}
            <span className="font-semibold text-accent-foreground">
              {formatTime(timeLeft)}
            </span>
          </p>
        ) : (
          <Button
            type="button"
            variant="link"
            className="p-0"
            onClick={() => {
              resendOtp();
              reset();
            }}
            disabled={isResending}
          >
            {isResending ? (
              <>
                <Spinner data-icon="inline-start" />
                Sending...
              </>
            ) : (
              "Resend code"
            )}
          </Button>
        )}
        <Separator />
        <Button
          type="button"
          variant="link"
          className="p-0"
          onClick={() => navigate(-1)}
        >
          <PenLine /> Did you enter the wrong number?
        </Button>
      </div>
    </section>
  );
};

export default VouchingVerify;
